import { AppButton, AppInput } from "components/antd-ui";
import { ChangeEvent, FormEvent, useState } from "react";

type LoginFormValues = {
  username: string;
  password: string;
};

type LoginFormProps = {
  loading?: boolean;
  onSubmit?: (values: LoginFormValues) => void | Promise<void>;
};

const LoginForm = ({ loading = false, onSubmit }: LoginFormProps) => {
  const [form, setForm] = useState<LoginFormValues>({
    username: "",
    password: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await onSubmit?.(form);
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <div className="login-form__field">
        <AppInput
          name="username"
          type="text"
          id="username"
          value={form.username}
          placeholder="Tên đăng nhập"
          size="large"
          onChange={handleChange}
        />
      </div>

      <div className="login-form__field">
        <AppInput
          inputType="password"
          name="password"
          id="userPassword"
          value={form.password}
          placeholder="Mật khẩu"
          size="large"
          onChange={handleChange}
        />
      </div>

      <AppButton
        htmlType="submit"
        tone="primary"
        size="large"
        loading={loading}
        className="login-form__submit"
      >
        Đăng nhập
      </AppButton>
    </form>
  );
};

export default LoginForm;
